import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap'
import Api from './Api'

class Subscribe extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            EmailSubscribe: '',
            Error: '',
            EmailError: '',
        };
    }
    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ EmailError: '', Error: '' })
        if (this.state.EmailSubscribe === '') {
            this.setState({ EmailError: "Username is empty." })
            return;
        }
        const FETCH_URL = 'api/auth/register';
        var data = {
            username: this.state.EmailSubscribe,
        }
        Api.PostApi(FETCH_URL, data, this.props.history).then(d => {
            if (d === undefined) {
                this.setState({ Error: "Username already registered in the system." });
            } else {
                alert('Email with password sent.');
            }
        })
    }
    render() {
        return (
            <div className="Subscribe">
                <h4>Aanmelden</h4>
                <hr />
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="formHorizontalSubscribeEmail">
                        <Col componentClass={ControlLabel} sm={2}>
                            E-mailadres
                </Col>
                        <Col sm={6}>
                            <FormControl required name='EmailSubscribe' onChange={this.handleChange} type="email" placeholder="e-mail adres - aanmelden" />
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col smOffset={2} sm={6}>
                            <Button type="submit">Aanmelden</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

export default Subscribe;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Subscribe.js